import { withStyles } from "@material-ui/core";
import PropTypes from "prop-types";
import React, { useMemo } from "react";
import { useIntl } from "react-intl";

import styles from "./styles";

const InputError = (props) => {
  const { classes, meta, style } = props;
  const shouldShow =
    (meta.dirty || meta.touched || meta.submitFailed) &&
    (meta.invalid || !!meta.error);

  const { formatMessage } = useIntl();
  const errStr = useMemo(
    () =>
      meta?.error?.id
        ? formatMessage(meta.error, meta.error.values ?? {})
        : meta.error,
    [meta, formatMessage],
  );

  return (
    <div
      className={`${classes.error} ${shouldShow && classes.visited}`}
      style={style}
      data-testid={props["data-testid"]}
    >
      {errStr}
    </div>
  );
};

InputError.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  meta: PropTypes.shape({
    dirty: PropTypes.bool,
    touched: PropTypes.bool,
    submitFailed: PropTypes.bool,
    invalid: PropTypes.bool,
    error: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        defaultMessage: PropTypes.string.isRequired,
        values: PropTypes.shape({}),
      }),
    ]),
  }),
  style: PropTypes.shape({}),
  "data-testid": PropTypes.string,
};

InputError.defaultProps = {
  classes: {},
  meta: {},
  style: undefined,
  "data-testid": "",
};

const MemoizedInputError = React.memo(InputError);
export default withStyles(styles)(MemoizedInputError);
